import Scene = Phaser.Scene;
import {Keys} from "@/constants/key";
import SpriteUtils from "@/utils/sprite-utils";

export class ClanTheme extends Phaser.GameObjects.Container {

    constructor(scene: Scene, x: number, t: string, callback: () => unknown) {
        super(scene);

        this.scene = scene;
        this.x = x;
        this.y = 0;

        const theme = SpriteUtils.addImage(this.scene, 0, 0, t);
        const border = SpriteUtils.addImage(this.scene, 0, 0, Keys.CLAN_THEME_BORDER);

        theme.setInteractive().on('pointerup', function() {
            callback();
        });

        this.add([theme, border]);
    }

    public setOrigin(x: number, y: number): void {
        // do nothing
    }

}
